"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const immutability_helper_1 = __importDefault(require("immutability-helper"));
const common_1 = require("@components/common");
const ExerciseTag_1 = __importDefault(require("./ExerciseTag"));
const ExerciseTagList = ({ tags, setTags }) => {
    const [, drop] = (0, react_dnd_1.useDrop)(() => ({ accept: "tag" }));
    const findCard = (0, react_1.useCallback)((id) => {
        const tag = tags.filter((c) => c.id === id)[0];
        return {
            tag,
            index: tags.indexOf(tag),
        };
    }, [tags]);
    const moveCard = (0, react_1.useCallback)((id, atIndex) => {
        const { tag, index } = findCard(id);
        setTags((0, immutability_helper_1.default)(tags, {
            $splice: [
                [index, 1],
                [atIndex, 0, tag],
            ],
        }));
    }, [findCard, tags, setTags]);
    const onRemove = (0, react_1.useCallback)(({ id }) => {
        const { index } = findCard(id);
        setTags(tags => {
            return (0, immutability_helper_1.default)(tags, {
                $splice: [
                    [index, 1]
                ],
            });
        });
    }, [findCard, tags, setTags]);
    return react_1.default.createElement(common_1.Flex, { gap: "10px", ref: drop }, tags.map(e => (react_1.default.createElement(ExerciseTag_1.default, { moveCard: moveCard, findCard: findCard, key: e.id, id: e.id, onRemove: onRemove }, e.name))));
};
exports.default = ExerciseTagList;
